import React from "react";
import { Link } from "react-router-dom";
import pawnaImage from "../Images/pawana/TriangleStay/tlights.jpg";
import panshetImage from "../Images/Panshet/TentStay/tnt1.jpg";

const ImageCard = () => {
  const cardsData = [
    {
      title: "Pawna Lake Camping",
      description:
        "Unwind by the lake with cozy stays, meals, music, and evenings around the bonfire.",
      image: pawnaImage,
      imageAlt: "A warmly lit campsite stay at Pawna Lake",
      path: "/pawana-camping",
      action: "Explore Pawna",
    },
    {
      title: "Panshet Lake Camping",
      description:
        "Enjoy a relaxed lakeside escape and explore the camping stay options at Panshet.",
      image: panshetImage,
      imageAlt: "Tents at the Panshet lakeside campsite",
      path: "/panshet-camping",
      action: "Explore Panshet",
    },
  ];

  return (
    <section className="bg-gradient-to-b from-amber-50 to-white px-4 py-10 sm:px-6 sm:py-14">
      <div className="mx-auto max-w-6xl">
        <p className="text-center text-xs font-bold uppercase tracking-[0.18em] text-emerald-800">
          Make time for the outdoors
        </p>
        <h1 className="mt-2 text-center text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">
          Find your lakeside stay
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-center text-sm leading-6 text-stone-600 sm:text-base">
          Compare our Pawna and Panshet camping experiences and choose the
          lakeside getaway that suits your group.
        </p>

        <div className="mt-8 grid gap-6 md:grid-cols-2">
          {cardsData.map((card) => (
            <article
              key={card.title}
              className="overflow-hidden rounded-3xl border border-amber-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-xl"
            >
              <Link to={card.path} className="group block">
                <div className="relative h-56 overflow-hidden sm:h-72">
                  <img
                    src={card.image}
                    alt={card.imageAlt}
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-stone-950/60 to-transparent" />
                  <h2 className="absolute bottom-5 left-5 text-2xl font-bold text-white sm:text-3xl">
                    {card.title}
                  </h2>
                </div>
                <div className="p-5 sm:p-6">
                  <p className="text-sm leading-6 text-stone-600 sm:text-base">
                    {card.description}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 font-semibold text-emerald-800">
                    {card.action}
                    <span
                      aria-hidden="true"
                      className="transition-transform group-hover:translate-x-1"
                    >
                      →
                    </span>
                  </span>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageCard;
